import { api } from './client';

// ─── Ad Diagnosis ──────────────────────────────────────────────

export interface AdDiagnoseMetrics {
  spend: number;
  roas: number;
  cpc: number;
  cpm: number;
  cpa: number;
  purchase_count: number;
}

export interface AdDiagnoseRequest {
  ad_id: string;
  ad_name: string;
  ad_type: 'text' | 'image' | 'video';
  platform: string;
  headline?: string;
  primary_text?: string;
  description?: string;
  cta?: string;
  metrics: AdDiagnoseMetrics;
  image_url?: string;
  video_url?: string;
  regenerate?: boolean;
}

export interface DiagnoseDimension {
  label: string;
  score: number;
}

export interface DiagnoseIssue {
  severity: 'critical' | 'warning' | 'good' | 'info';
  title: string;
  desc: string;
  impact: string;
}

export interface DiagnoseSuggestion {
  title: string;
  desc: string;
  tag: string;
  tag_type: 'green' | 'amber' | 'red' | 'blue';
}

export interface DiagnoseRewrite {
  old: string;
  old_score: number;
  new: string;
  new_score: number;
}

export interface DiagnoseVideoScene {
  time: string;
  title: string;
  desc: string;
  score: number;
}

export interface AdDiagnoseResponse {
  score: number;
  grade: string;
  dimensions: DiagnoseDimension[];
  issues: DiagnoseIssue[];
  suggestions: DiagnoseSuggestion[];
  rewrite?: DiagnoseRewrite | null;
  video_scenes?: DiagnoseVideoScene[];
}

export async function diagnoseAd(req: AdDiagnoseRequest): Promise<AdDiagnoseResponse> {
  return api.post<AdDiagnoseResponse>('/ai/ad-diagnose', req);
}

/** Fetch cached diagnosis result. Returns null if not found (404). */
export async function getAdDiagnosis(adId: string, platform: string): Promise<AdDiagnoseResponse | null> {
  try {
    return await api.get<AdDiagnoseResponse>(`/ai/ad-diagnose?ad_id=${encodeURIComponent(adId)}&platform=${encodeURIComponent(platform)}`);
  } catch {
    return null;
  }
}
